export default __webpack_public_path__ + "static/media/IconDashSetting.77875c47.svg";